/**
 * Replaces decimal point with decimal comma.
 */
export function formatPercentageForTexts(value: number): string {
  return String(value).replace('.', ',');
}
